const contentTemplate = document.querySelector('#contentTemplate') as HTMLTemplateElement;
const noResearchTemplate = document.querySelector('#noResearchTemplate') as HTMLTemplateElement;
const errorTemplate = document.querySelector('#errorTemplate') as HTMLTemplateElement;

export const LOADING = document.querySelector('#loader') as HTMLDivElement;
export const CONTENT = document.querySelector('.content') as HTMLDivElement;
export const CONTENT_TEMPLATE = contentTemplate.content.cloneNode(true);
export const NO_RESEARCH_CONTENT_TEMPLATE = noResearchTemplate.content.cloneNode(true);
export const ERROR_TEMPLATE = errorTemplate.content.cloneNode(true);
